<template>
    <header>
        <div class="title" v-html="title"></div><!-- TODO à remplacer par le composant HeaderTitle -->
    </header>
</template>

<script>
    import {eventBus} from '../main';

    export default {
        data() {
            return {
                title: ''
            }
        },
        created() {
            eventBus.$on('changeService', (data) => {
                this.title = data;
            });
        }
    }
</script>


// WEBPACK FOOTER //
// Header.vue?84474aa8